(function(){
    angular
        .module('appback')
        .directive('ngRecepcionarpedido', recepcionarPedido);
        recepcionarPedido.$inject = ['PedidosService','$timeout', 'Upload', '$uibModal'];
        function recepcionarPedido(PedidosService,$timeout, Upload, $uibModal){
            return {
              templateUrl: '/backend/pedidos/template?name=recepcionarpedido.twig',
		        scope: {
                    pc:'=',
                },
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {

                        scope.reset = function(){
                            console.log("reseteando valores");
                            scope.transporteID = false;
                            scope.nuevoTransporte = {
                                costeTransporte: 0,
                                costeTransporteIva: 0,
                                costes: [{
                                    uid: Date.now(),
                                    valor: 0,
                                    iva: 0,
                                    tipo: "", //transporte por defecto
                                    divisa: scope.pc.pedidoActivo.proveedor.divisa_id
                                }], 
                                fecha: scope.formatearFechaHoy(),
                                proveedor: ""
                            };
                        }

                        scope.formatearFechaHoy = function() {
                            const hoy = new Date();
                            const yyyy = hoy.getFullYear();
                            const mm = String(hoy.getMonth() + 1).padStart(2, '0');
                            const dd = String(hoy.getDate()).padStart(2, '0');
                            return `${yyyy}-${mm}-${dd}`;  
                        }

                        scope.transporteID = false;
                        scope.nuevoTransporte = {
                            costeTransporte: 0,
                            costeTransporteIva: 0,
                            costes: [{
                                uid: Date.now(),
                                valor: 0,
                                iva: 0,
                                tipo: "", //transporte por defecto
                                divisa: scope.pc.pedidoActivo.proveedor.divisa_id
                            }], 
                            fecha: scope.formatearFechaHoy(),
                            proveedor: ""
                        };

                        scope.getTipoCoste = function(coste) {
                            console.log("getting tipo coste", coste);
                            PedidosService.getTipoCoste(coste.tipo, function(data){
                                console.log("data getTipoCoste", data);
                                if(data.tipo_coste != null){
                                    var iva = 0;
                                    if(angular.isDefined(data.tipo_coste.iva) && data.tipo_coste.iva.porcentaje > 0){
                                        iva = data.tipo_coste.iva.porcentaje;
                                    }
                                    coste.iva = iva;
                                }
                                scope.calcularCosteTotalTransporte();
                            });
                        }

                        scope.agregarCoste = function() {
                            scope.nuevoTransporte.costes.push({
                                uid: Date.now(),
                                valor: 0,
                                tipo: '',
                                divisa: scope.pc.pedidoActivo.proveedor.divisa_id
                            });
                        };

                        scope.eliminarCoste = function(index) {
                            scope.nuevoTransporte.costes.splice(index, 1);
                            scope.calcularCosteTotalTransporte();  
                        };

                        scope.calcularCosteTotalTransporte = function() {
                            var total = 0;
                            var total_iva = 0;
                            scope.nuevoTransporte.costes.forEach(function(coste) {
                              total += parseFloat(coste.valor) || 0;
                              total_iva += parseFloat(coste.valor * (1 + (coste.iva / 100))) || coste.valor;
                            });
                            scope.nuevoTransporte.costeTransporte = total;
                            scope.nuevoTransporte.costeTransporteIva = total_iva;
                        };

                        scope.getUnidadesLotesLinea = function(linea){
                            console.log("getUnidadesLotes linea: ", linea);
                            var unidades = 0;
                            if(angular.isArray(linea.lotes) && linea.lotes.length > 0){
                                linea.lotes.forEach(lote => {
                                    unidades += parseFloat(lote.unidades) || 0;
                                });
                            }
                            return unidades;
                        }

                        scope.getUnidadesNuevoLote = function(linea){
                            var unidades = linea.pendientes_recepcion - scope.getUnidadesLotesLinea(linea);
                            if(unidades <= 0){
                                return 0;
                            }
                            return unidades;
                        }

                        scope.agregarLote = function(linea) {
                            if (!linea.lotes) {
                              linea.lotes = [];
                            }
                            var unidades_lote = scope.getUnidadesNuevoLote(linea);
                            linea.lotes.push({
                                uid: Date.now(), // Un ID temporal único
                                unidades: unidades_lote,
                                lote: '',
                                fechaCaducidad: null,
                                almacen_id: ""
                            });
                            scope.calcularCosteLinea(linea);
                        };

                        scope.eliminarLote = function(linea, index) {
                            linea.lotes.splice(index, 1);
                            scope.calcularCosteLinea(linea);  
                        };

                        scope.eliminarLinea = function(index) {
                            console.log("eliminando linea", index);
                            scope.pc.pedidoActivo.lineaspedido.splice(index, 1);
                        };

                        scope.agregarMaterial = function(){
                            console.log("agregando material");
                            scope.pc.pedidoActivo.lineaspedido.push({
                                id: Date.now(), //Id temporal único
                                cantidad: 0,
                                material_id: null,
                                pendientes_recepcion: 0,
                                extra: true,
                            });
                        }

                        scope.getFactorIva = function(linea){
                            console.log("getting factor iva", linea);
                            if(angular.isDefined(linea.productoproveedor.iva) && linea.productoproveedor.iva.porcentaje > 0){
                                linea.productoproveedor.iva.valor = 1 + (linea.productoproveedor.iva.porcentaje / 100);
                            }
                        }

                        scope.checkRecepcionarLineas = function(){
                            //console.log("check recepcionar lineas", scope.pc.pedidoActivo);
                            var existen_recibidas = false;
                            for (let linea of scope.pc.pedidoActivo.lineaspedido) {
                                if(angular.isArray(linea.lotes) && linea.lotes.length > 0){
                                    existen_recibidas = true;
                                    for (let lote of linea.lotes) {
                                        if (lote.unidades <= 0) {
                                            console.log("No hay unidades en el lote: ", lote);
                                            return false;
                                        }
                                    }
                                }
                            }
                            return existen_recibidas;
                        }

                        scope.calcularCosteLinea = function(linea){
                            var total = 0;
                            var unidades_lineapedido = scope.getUnidadesLotesLinea(linea);
                            if(unidades_lineapedido > 0){
                                var descuento_aplicable = linea.descuento > 0? 1-linea.descuento/100 : 1;
                                total += linea.precio * descuento_aplicable * unidades_lineapedido;
                            }
                            linea.costeTotal = total;
                            var total_iva = total;
                            if(angular.isDefined(linea.productoproveedor.iva) && linea.productoproveedor.iva.porcentaje > 0){
                                total_iva = total * linea.productoproveedor.iva.valor;
                            }
                            linea.costeTotalIva = total_iva;
                            console.log("calcular coste linea", linea, unidades_lineapedido, total, total_iva);
                        }

                        //revisar cuando hay mas de un lote en la linea recibida
                        scope.calcularCosteTotalLineas = function(){
                            var total = 0;
                            for (let linea of scope.pc.pedidoActivo.lineaspedido) {
                                if(angular.isDefined(linea.costeTotal) && linea.costeTotal > 0)  {
                                    total += linea.costeTotal;
                                }
                            }
                            return total;
                        }

                        scope.calcularCosteTotalLineasIva = function(){
                            var total_iva = 0;
                            for (let linea of scope.pc.pedidoActivo.lineaspedido) {
                                if(angular.isDefined(linea.costeTotalIva) && linea.costeTotalIva > 0)  {
                                    total_iva += linea.costeTotalIva;
                                }
                            }
                            return total_iva;
                        }

                        scope.recepcionarLineas = function(){
                            console.log("recepcionando lineas", scope.pc.pedidoActivo, scope.nuevoTransporte);
                            console.log("lo que envio", scope.pc.pedidoActivoID, scope.nuevoTransporte, scope.pc.pedidoActivo.lineaspedido);
                            PedidosService.recepcionarLineasPedido(scope.pc.pedidoActivoID, scope.nuevoTransporte, scope.pc.pedidoActivo.lineaspedido,scope.pc.pedidoActivo.proveedor.divisa_id,function(data){
                                console.log("return data recepcionar lineas", data);
                                if(data.pedido){
                                    scope.pc.pedidoActivo = data.pedido;
                                    scope.reset();
                                }
                            });
                        }

                        scope.confirmarFinalizarRecepcion = function() {
                            $('#confirmFinalizarModal').modal('hide');
                            scope.finalizarRecepcion();
                        };

                        scope.finalizarRecepcion = function(){
                            if (scope.formRecepcion.$valid && scope.checkRecepcionarLineas()) {
                                PedidosService.recepcionarLineasPedido(scope.pc.pedidoActivoID, scope.nuevoTransporte, scope.pc.pedidoActivo.lineaspedido,scope.pc.pedidoActivo.proveedor.divisa_id,function(data){
                                    if(data.pedido){
                                        PedidosService.finalizarPedido(scope.pc.pedidoActivoID, function(dataFinalizar){
                                            console.log("return data finalizar pedido despues de guardar ultima recepcion", dataFinalizar);
                                            if(dataFinalizar.pedido){
                                                scope.pc.pedidoActivo = dataFinalizar.pedido;
                                            }
                                        })
                                    }
                                });
                            }else{
                                PedidosService.finalizarPedido(scope.pc.pedidoActivoID, function(data){
                                    console.log("return data finalizar pedido", data);
                                    if(data.pedido){
                                        scope.pc.pedidoActivo = data.pedido;
                                    }
                                });
                            }
                        }

                        scope.modalEditarTransporte = false;
                        scope.openModalEditarTransporte = function(transporte_id){
                            console.log("abrir modal editar transporte", transporte_id);
                            PedidosService.getTransportePedido(transporte_id, function(data){
                                console.log("data get transporte pedido", data);
                                if(data.code > 0){
                                    scope.modalEditarTransporte = $uibModal.open({
                                        animation: true,
                                        ariaLabelledBy: 'modal-title-top',
                                        ariaDescribedBy: 'modal-body-top',
                                        templateUrl: 'editarTransporte.html',
                                        size: 'lg',
                                        controller: function($scope) {
                                            $scope.pc = scope.pc;
                                            $scope.transporte = data.transporte;

                                            $scope.agregarCosteEdit = function() {
                                                $scope.transporte.costes_recepcion.push({
                                                    uid: Date.now(),
                                                    coste: 0,
                                                    tipo_coste_id: '',
                                                    divisa: scope.pc.pedidoActivo.proveedor.divisa_id
                                                });
                                            };

                                            $scope.eliminarCosteEdit = function(index) {
                                                $scope.transporte.costes_recepcion.splice(index, 1);
                                            };

                                            $scope.getTipoCosteEdit = function(coste) {
                                                console.log("getting tipo coste", coste);
                                                PedidosService.getTipoCoste(coste.tipo_coste_id, function(data){
                                                    console.log("data getTipoCoste", data);
                                                    if(data.tipo_coste != null){
                                                        var iva = 0;
                                                        if(angular.isDefined(data.tipo_coste.iva) && data.tipo_coste.iva.porcentaje > 0){
                                                            iva = data.tipo_coste.iva.porcentaje;
                                                        }
                                                        coste.iva = iva;
                                                    }
                                                });
                                            }

                                            $scope.agregarMaterialEdit = function(){
                                                console.log("agregando material edit");
                                                $scope.transporte.lineas_recepcion_transporte.push({
                                                    uid: Date.now(), //Id temporal único
                                                    material_id: null,
                                                    extra: true,
                                                });
                                            }

                                            $scope.eliminarLineaEdit = function(index) {
                                                console.log("eliminando linea", index);
                                                $scope.transporte.lineas_recepcion_transporte.splice(index, 1);
                                            };

                                            $scope.agregarLoteEdit = function(linea) {
                                                if (!linea.lotes) {
                                                linea.lotes = [];
                                                }
                                                linea.lotes.push({
                                                    uid: Date.now(), // Un ID temporal único
                                                    unidades: 0,
                                                    lote: '',
                                                    fecha_caducidad: null,
                                                    almacen_id: ""
                                                });
                                            };

                                            $scope.eliminarLoteEdit = function(linea, index) {
                                                linea.lotes.splice(index, 1);
                                            };

                                            $scope.checkRecepcionarLineasEdit = function(){
                                                var existen_recibidas = false;
                                                for (let linea of $scope.transporte.lineas_recepcion_transporte) {
                                                    if(angular.isArray(linea.lotes) && linea.lotes.length > 0){
                                                        existen_recibidas = true;
                                                        for (let lote of linea.lotes) {
                                                            if (lote.unidades <= 0) {
                                                                console.log("No hay unidades en el lote: ", lote);
                                                                return false;
                                                            }
                                                        }
                                                    }else{
                                                        return false;
                                                    }
                                                }
                                                return existen_recibidas;
                                            }

                                            $scope.okForm = function(){
                                                console.log("guardando transporte", $scope.transporte);
                                                PedidosService.guardarTransportePedido($scope.transporte,scope.pc.pedidoActivo.proveedor.divisa_id, function(data){
                                                    console.log("data return guardar transporte", data);
                                                    if(data.code > 0){
                                                        scope.modalEditarTransporte.close(data.pedidoActivo.pedido);
                                                    }
                                                })
                                            }
        
                                            $scope.koForm = function(){
                                                scope.modalEditarTransporte.close();
                                            }
                                        }
                                    });

                                    scope.modalEditarTransporte.result.then(function (pedidoActualizado) {
                                        if (pedidoActualizado) {
                                            scope.pc.pedidoActivo = pedidoActualizado;
                                        }
                                    }, function () {
                                        console.log('Modal de edición de transporte cerrado sin cambios.');
                                    });
                                }
                            });
                        }
			        });
		        }
          }
      }
})();